// ** Third Party Imports
import styled, { css } from 'styled-components'

// ** Component Imports
import {
	Heading,
	IconButton,
	Typography,
	Dialog,
	InputField
} from '@/shared/ui'

// ** Type Imports
import { type CSSProperties } from 'react'

export const StyledDialogContent = styled(Dialog.Content)`
	max-width: 40rem;
	z-index: 1000;
	text-align: center;
	padding: 2.5rem 2rem;
`

export const StyledDialogShareContent = styled(Dialog.Content)`
	max-width: 42rem;
`

export const StyledItem = styled.div`
	padding: 6px 2px;
	display: flex;
	align-items: center;
	cursor: pointer;
	gap: 0.5rem;
	padding-left: 0.5rem;

	&:not(:last-child) {
		border-bottom: 1px solid #848898;
	}

	&:hover {
		background-color: #f9fafb;
	}
`

export const StyledHeading = styled(Heading)`
	color: ${({ theme }) => theme.pallette.text.black75};
	margin-bottom: 2rem;
`

export const StyledTypography = styled(Typography)`
	color: ${({ theme }) => theme.pallette.text.black75};
	margin-bottom: 2rem;
`

export const ManualStrategyField = styled(InputField)`
	cursor: default;
	pointer-events: none;
`

export const DescriptionTitle = styled(Heading)`
	margin: 1rem 0 0.5rem;
`

export const EditStrategyButton = styled(IconButton)`
	& svg {
		path {
			stroke: ${({ theme }) => theme.pallette.text.black50};
		}
	}
`
export const StyledTrigger = styled.div`
	display: flex;
	align-items: center;
	justify-content: start;
	gap: 0.5rem;
`

export const LoaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 2rem;
	align-items: center;
	justify-content: center;
`

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 2rem;
	margin-bottom: 1rem;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;

	& > button {
		width: 100%;
	}
`

export const Stack = styled.div<{ $styles?: CSSProperties }>`
	display: flex;
	${({ $styles }) => ({ ...$styles })}
`

export const ClientCalculationWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	justify-content: space-between;
	margin-bottom: 1.5rem;
	margin-top: 4.5rem;

	& .calculate-home-office-tax-deduction-client-form-wrapper {
		display: flex;
		flex-direction: column;
		gap: 3rem;

		& .business-income {
			margin-top: 0;
			margin-bottom: 0;
		}

		& .indirect-expenses-own,
		.indirect-expenses-rent,
		.direct-expenses,
		.depreciation {
			margin-top: 0;
		}
	}
`
export const LabelAndInputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 1rem;
`

export const StyledNavigation = styled.nav`
	position: absolute;
	top: 0;
	height: 4.5em;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.pallette.primary.main};
`

export const StatusWrapper = styled.nav`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	row-gap: 3rem;
`

export const StatusMessages = styled.nav`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	row-gap: 1rem;
`

export const InputsWrapper = styled.div<{ $styles?: CSSProperties }>`
	display: flex;
	flex-direction: row;
	column-gap: 0.5rem;
	width: 100%;
	${({ $styles }) => ({ ...$styles })}

	& > div {
		flex: 1;
		margin: 0;
	}
`

export const FieldsWrapper = styled.div<{ $onNewPublicPage?: boolean }>`
	gap: 1rem;
	display: flex;
	flex-direction: column;

	${({ $onNewPublicPage }) =>
		$onNewPublicPage &&
		css`
			label {
				font-family: 'Fustat', sans-serif;
				font-optical-sizing: auto;
				font-style: normal;
			}

			input {
				font-family: 'Fustat', sans-serif;
				font-optical-sizing: auto;
				font-style: normal;
			}
		`}
`

export const StyledTitle = styled.h4`
	font-family: 'Fustat', sans-serif;
	font-optical-sizing: auto;
	font-style: normal;
	font-size: 1.6rem;
	font-weight: 600;
	margin-bottom: 1rem;
`

export const BaseTypography = styled(Typography)`
	font-family: 'Fustat', sans-serif;
	font-optical-sizing: auto;
	font-style: normal;
`

export const StyledTypographyPublic = styled(BaseTypography)`
	font-weight: 300;
	font-size: 1rem;
	color: #000;
	margin-bottom: 2rem;
`
